import { Outlet, useLocation } from 'react-router-dom'
import { SettingsMenu } from './settings-menu/SettingsMenu'

function SettingsPage() {
  const { pathname } = useLocation()

  return (
    <div className="min-h-[calc(100svh-100px)] w-screen max-w-screen flex flex-col-reverse md:flex-row">
      <div className="flex flex-col flex-1 min-w-0">
        <Outlet />
      </div>
      <div className="md:border-l md:border-border shrink-0">
        <SettingsMenu activeRoute={pathname} />
      </div>
    </div>
  )
}

export default SettingsPage
